// assets
import { ProfileOutlined, TeamOutlined, UnorderedListOutlined } from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';
import { Rights } from '../graphql/types';

// icons
const icons = {
  TeamOutlined,
  ProfileOutlined,
  UnorderedListOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const users: NavItemType = {
  id: 'group-users',
  type: 'group',
  children: [
    {
      id: 'view-profile',
      title: 'Profile',
      type: 'item',
      hidden: true,
      url: '/profiles/account/basic',
      icon: { anticon: icons.ProfileOutlined }
    }
  ]
};

export default users;
